import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium transition-all duration-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 relative z-10 h-10 px-6 py-2.5",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:scale-110 hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(6,182,212,0.5),0_0_100px_rgba(249,115,22,0.3)]",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:scale-105 hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(239,68,68,0.5)]",
        outline:
          "border-2 border-input shadow-sm hover:border-[#F97316] hover:scale-105 hover:-translate-y-1 hover:shadow-[0_10px_40px_rgba(249,115,22,0.4)]",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:scale-105 hover:-translate-y-1 hover:shadow-[0_15px_50px_rgba(249,115,22,0.6)]",
        ghost: "hover:bg-accent hover:text-accent-foreground hover:scale-105 hover:shadow-lg",
        link: "text-primary underline-offset-4 hover:underline hover:text-[#F97316]",
      },
      size: {
        default: "h-10 px-6 py-2.5",
        sm: "h-9 px-4 py-2",
        lg: "h-11 px-8 py-3",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
